import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { TokenLink } from './token-link';
export { TokenLink };
import { tokenLinkSchema } from '@schemas/business-objects/token-link';
import { TokenFormGroup } from './token-form-group';

export class TokenLinkFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    downstreamTokenId: SchemaFormControl;
    downstreamToken: TokenFormGroup;
    upstreamTokenId: SchemaFormControl;
    upstreamToken: TokenFormGroup;
  };

  declare value: Partial<TokenLink>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(tokenLinkSchema, TokenLink, data, options);
  }

  get object(): TokenLink {
    return new TokenLink(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'downstreamToken':
        return new TokenFormGroup();
      case 'upstreamToken':
        return new TokenFormGroup();
      default:
        return undefined;
    }
  }
}

export class TokenLinkFormArray extends PersistedFormArray {
  readonly entityName = 'TokenLink' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(tokenLinkSchema, TokenLink, options);
  }

  protected override createItemGroup() {
    return new TokenLinkFormGroup();
  }

  get array(): TokenLink[] {
    return this.controls.map((group: TokenLinkFormGroup) => group.object);
  }
}

export class TokenLinkPersistedArray extends PersistedArray<TokenLink> {
  readonly entityName = 'TokenLink' as const;

  constructor(options?: PersistedArrayOptions) {
    super(TokenLink, options);
  }
}
